/**
 * Powrót na ekran zgody „Podłącz AI” po zalogowaniu. Trzymamy tylko ścieżkę
 * (nie token) i tylko tę jedną trasę — inaczej to otwarte przekierowanie.
 */
const KEY = "farmaster_post_login_redirect";
const ALLOWED = /^\/polacz-ai\/zgoda\?request=[A-Za-z0-9_-]+$/;

export function rememberPostLoginRedirect(path: string): void {
	if (!ALLOWED.test(path)) return;
	try {
		sessionStorage.setItem(KEY, path);
	} catch {
		// sessionStorage moze byc wylaczony (Safari private) — wtedy uzytkownik wraca do dashboardu
	}
}

export function takePostLoginRedirect(): string | null {
	try {
		const value = sessionStorage.getItem(KEY);
		sessionStorage.removeItem(KEY);
		return value && ALLOWED.test(value) ? value : null;
	} catch {
		return null;
	}
}
